var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useIsPhone } from '../../utilities/hooks/isPhone';
import { Image } from '../Image';
export var ImageFromCdn = function (_a) {
  var src = _a.src,
    restOfProps = __rest(_a, ["src"]);
  // @ts-expect-error - Need to improve tuple implementation
  var _b = src.split('|'),
    originAndPath = _b[0],
    _c = _b[1],
    alignment = _c === void 0 ? 'center' : _c;
  var _d = originAndPath.split(':'),
    origin = _d[0],
    path = _d[1];
  var allowedOrigins = ['assets-cdn'];
  var allowedAlignments = ['left', 'center', 'right'];
  var imageAlign = allowedAlignments.includes(alignment) ? alignment : 'center';
  var isPhone = useIsPhone();
  var imgPath = isPhone ? "mobile-".concat(path) : "default-".concat(path);
  if (allowedOrigins.includes(origin)) {
    return _jsx(Image, __assign({}, restOfProps, {
      src: "https://".concat(origin, ".moneyfarm.com/images/").concat(imgPath),
      align: imageAlign
    }));
  }
  return null;
};